<template>
  <v-btn
    :disabled="disabled"
    small
    @click="$emit('click')"
    class="btn-edit m-1"
  >
    <i class="fas fa-pen mr-2 text-twenty"></i>
    EDITAR
  </v-btn>
</template>

<script>
export default {
  name: "VDataTableEditButton",

  props: {
    disabled: { type: Boolean, default: false },
  },
};
</script>

<style>
</style>